__turbopack_context__.v({
  "expanded": "index-module-scss-module__9ay6eW__expanded",
  "fullscreenPanel": "index-module-scss-module__9ay6eW__fullscreenPanel",
});
